import { localStorage as local } from '@entrata/utils'
import { CLUSTER_KEY } from 'portal-modules/common/constants/keys'
import getProjectConditions from 'portal-modules/common/utils/get-project-conditions'
const { isTP } = getProjectConditions()

export default () => {
  if (isTP) {
    return (sessionStorage.getItem(CLUSTER_KEY) || '2') === '2'
      ? 'sync'
      : 'rsync'
  }
  return (local.get(CLUSTER_KEY) || '2') === '2' ? 'sync' : 'rsync'
}
